import { useFormContext } from 'react-hook-form';
import Dropdown from 'src/components/input/Dropdown';
import toTwoDecimals from 'src/utils/toTwoDecimals';
import type { Plan } from '../types';
import useFetchCost from '../hooks/useFetchCost';

export default function PlanDropdown() {
  const { register } = useFormContext();

  return (
    <Dropdown placeholder="Select your plan..." selectProps={register('plan')}>
      <PlanOption plan="monthly" />
      <PlanOption plan="yearly" />
    </Dropdown>
  );
}

function PlanOption({ plan }: { plan: Plan }) {
  const { watch } = useFormContext();
  const countryCode = watch('country');
  const isEuropeanUnion = watch('isEuropeanUnion');
  const { percentOff, amountOff, duration } = watch('discount');

  const { cost, currencySymbol } = useFetchCost({
    plan,
    countryCode,
    isEuropeanUnion,
  });

  const planName = plan[0].toUpperCase() + plan.slice(1); // capitalize plan
  const planPeriod = plan.slice(0, -2); // remove 'ly' from plan

  function getDiscountedCost() {
    // if coupon is one-off, we want to show the full price in the dropdown
    if (duration === 'once') {
      return cost;
    }
    if (percentOff) {
      return cost - cost * (percentOff / 100);
    }
    if (amountOff) {
      return cost - amountOff;
    }
    return cost;
  }

  return (
    <option
      value={plan}
    >{`${planName} plan (${currencySymbol}${toTwoDecimals(getDiscountedCost())}/${planPeriod})`}</option>
  );
}
